customElements.get("product-form") || customElements.define("product-form", class extends HTMLElement {
    constructor() {
        super(),
        this.querySelector("form")
            ? (this.form = this.querySelector("form"),
               this.form.querySelector("[name=id]").disabled = !1,
               this.form.addEventListener("submit", this.onSubmitHandler.bind(this)))
            : (this.querySelector("[name=id]").disabled = !1,
               this.querySelector("button[type=submit]").addEventListener("click", this.onSubmitHandler.bind(this))),
        this.cart = document.querySelector("cart-notification") || document.querySelector("cart-drawer"),
        this.submitButton = this.querySelector('[type="submit"]'),
        document.querySelector("cart-drawer") && this.submitButton.setAttribute("aria-haspopup", "dialog"),
        this.hideErrors = "true" === this.dataset.hideErrors
    }

    onSubmitHandler(e) {
        if (e.preventDefault(), "true" !== this.submitButton.getAttribute("aria-disabled")) {
            this.handleErrorMessage(),
            this.submitButton.setAttribute("aria-disabled", !0),
            this.submitButton.classList.add("loading"),
            this.querySelector(".loading-overlay__spinner").classList.remove("hidden");

            e = fetchConfig("javascript");
            e.headers["X-Requested-With"] = "XMLHttpRequest",
            delete e.headers["Content-Type"];

            let r = new FormData(this.form);
            this.form || r.append("id", this.querySelector("[name=id]").value);

            // Store section IDs for fallback use
            let sectionIds = [];
            if (this.cart) {
                try {
                    sectionIds = this.cart.getSectionsToRender().map(e => e.id);
                } catch (err) {
                    console.warn("Could not get sections to render:", err);
                }
                r.append("sections", sectionIds);
                r.append("sections_url", window.location.pathname);
                this.cart.setActiveElement(document.activeElement);
            }

            e.body = r;

            fetch("" + routes.cart_add_url, e)
                .then(e => e.json())
                .then(async e => {
                    var t;

                    if (e.status) return publish(PUB_SUB_EVENTS.cartError, {
                        source: "product-form",
                        productVariantId: r.get("id"),
                        errors: e.description,
                        message: e.message
                    }), this.handleErrorMessage(e.description),
                    (t = this.submitButton.querySelector(".sold-out-message"))
                        ? (this.submitButton.setAttribute("aria-disabled", !0),
                           this.submitButton.querySelector("span").classList.add("hidden"),
                           t.classList.remove("hidden"),
                           void(this.error = !0))
                        : void 0;

                    if (this.cart) {
                        this.error || publish(PUB_SUB_EVENTS.cartUpdate, {
                            source: "product-form",
                            productVariantId: r.get("id")
                        });
                        this.error = !1;

                        // ---- CHECK: Did Shopify return valid sections? ----
                        const hasSections = e.sections &&
                            Object.keys(e.sections).length > 0 &&
                            Object.values(e.sections).every(v => v !== null);

                        if (!hasSections && sectionIds.length > 0) {
                            console.warn("Sections missing from /cart/add response, fetching manually...");
                            e.sections = await this.fetchSectionsFallback(sectionIds);
                        }

                        t = this.closest("quick-add-modal");

                        if (t) {
                            document.body.addEventListener("modalClosed", () => {
                                setTimeout(() => {
                                    this.safeRenderContents(e, sectionIds);
                                });
                            }, { once: !0 });
                            t.hide(!0);
                        } else {
                            this.safeRenderContents(e, sectionIds);
                        }

                    } else {
                        window.location = window.routes.cart_url;
                    }
                })
                .catch(e => {
                    console.error(e);
                    // Items may still be added — update cart bubble as safety net
                    this.updateCartBubbleFallback();
                })
                .finally(() => {
                    this.submitButton.classList.remove("loading"),
                    this.cart && this.cart.classList.contains("is-empty") && this.cart.classList.remove("is-empty"),
                    this.error || this.submitButton.removeAttribute("aria-disabled"),
                    this.querySelector(".loading-overlay__spinner").classList.add("hidden");
                });
        }
    }


    // =============================================
    // SAFE RENDER: Try renderContents with fallbacks
    // =============================================
    async safeRenderContents(data, sectionIds) {

        // ---- METHOD 1: Standard renderContents ----
        if (data.sections && Object.values(data.sections).every(v => v !== null)) {
            try {
                this.cart.renderContents(data);
                initUpsellSwiper();
                console.log("Cart updated via METHOD 1: renderContents");
                return;
            } catch (e) {
                console.warn("METHOD 1 renderContents failed:", e);
            }
        }

        // ---- METHOD 2: Fetch sections via Section Rendering API, then renderContents ----
        if (sectionIds.length > 0) {
            try {
                const sectionsParam = sectionIds.join(",");
                const res = await fetch(`${window.location.pathname}?sections=${sectionsParam}`);
                const sectionsData = await res.json();

                const allValid = Object.values(sectionsData).every(v => v !== null);
                if (allValid) {
                    data.sections = sectionsData;
                    this.cart.renderContents(data);
                    console.log("Cart updated via METHOD 2: Section Rendering API");
                    return;
                }
            } catch (e) {
                console.warn("METHOD 2 failed:", e);
            }
        }

        // ---- METHOD 3: Fetch /cart HTML and swap drawer DOM directly ----
        try {
            const res = await fetch("/cart");
            const html = await res.text();
            const parser = new DOMParser();
            const doc = parser.parseFromString(html, "text/html");

            const remoteDrawer = doc.querySelector("#shopify-section-cart-drawer") ||
                doc.querySelector("[id*='cart-drawer']");
            const localDrawer = document.querySelector("#shopify-section-cart-drawer") ||
                document.querySelector("[id*='cart-drawer']");

            if (remoteDrawer && localDrawer) {
                localDrawer.innerHTML = remoteDrawer.innerHTML;
                console.log("Cart updated via METHOD 3: /cart DOM swap");
                this.openCartDrawer();
                return;
            }
        } catch (e) {
            console.warn("METHOD 3 failed:", e);
        }

        // ---- METHOD 4: Dispatch events + click cart icon ----
        try {
            document.dispatchEvent(new CustomEvent("cart:refresh"));
            document.dispatchEvent(new CustomEvent("cart:build"));

            const cartIcon = document.querySelector('a[href="/cart"]') ||
                document.querySelector('.cart-icon-bubble') ||
                document.querySelector('[data-cart-toggle]') ||
                document.querySelector('cart-icon-bubble');

            if (cartIcon) {
                cartIcon.click();
                console.log("Cart updated via METHOD 4: event dispatch + icon click");
                return;
            }
        } catch (e) {
            console.warn("METHOD 4 failed:", e);
        }

        // ---- LAST RESORT: Just update the count bubble ----
        console.warn("All render methods failed, updating cart bubble only");
        this.updateCartBubbleFallback();
    }


    // =============================================
    // FALLBACK: Fetch sections manually
    // =============================================
    async fetchSectionsFallback(sectionIds) {
        try {
            const sectionsParam = sectionIds.join(",");
            const res = await fetch(`${window.location.pathname}?sections=${sectionsParam}`);
            const sectionsData = await res.json();

            const allValid = Object.values(sectionsData).every(v => v !== null);
            if (allValid) {
                console.log("Sections recovered via Section Rendering API");
                return sectionsData;
            }
        } catch (e) {
            console.warn("Section Rendering API fallback failed:", e);
        }

        // Fallback: parse /cart page HTML
        try {
            const res = await fetch("/cart");
            const html = await res.text();
            const parser = new DOMParser();
            const doc = parser.parseFromString(html, "text/html");
            const sections = {};

            sectionIds.forEach(id => {
                const el = doc.getElementById(`shopify-section-${id}`) || doc.querySelector(`[id*="${id}"]`);
                if (el) sections[id] = el.outerHTML;
            });

            if (Object.keys(sections).length > 0) {
                console.log("Sections recovered via /cart HTML parse");
                return sections;
            }
        } catch (e) {
            console.warn("/cart HTML parse fallback failed:", e);
        }

        return null;
    }


    // =============================================
    // HELPER: Open cart drawer after DOM swap
    // =============================================
    openCartDrawer() {
        try {
            const drawer = document.querySelector("cart-drawer");
            if (drawer) {
                if (typeof drawer.open === "function") {
                    drawer.open();
                } else {
                    drawer.classList.add("is-open", "active");
                    drawer.setAttribute("open", "");
                }
            }
        } catch (e) {
            console.warn("Could not auto-open drawer:", e);
        }
    }


    // =============================================
    // LAST RESORT: Update cart count bubble
    // =============================================
    async updateCartBubbleFallback() {
        try {
            const res = await fetch("/cart.js", {
                headers: { "Accept": "application/json" }
            });
            const cartData = await res.json();
            const count = cartData.item_count;

            const selectors = [
                ".cart-count",
                ".cart-count-bubble span",
                "[data-cart-count]",
                ".cart-icon-bubble span",
                "#cart-icon-bubble span",
                ".header__cart-count",
                ".js-cart-count"
            ];

            selectors.forEach(sel => {
                document.querySelectorAll(sel).forEach(el => {
                    el.textContent = count;
                });
            });

            const bubble = document.querySelector(".cart-count-bubble") ||
                document.querySelector("[data-cart-count-bubble]");
            if (bubble) {
                bubble.style.display = "";
                bubble.removeAttribute("hidden");
            }

            console.log(`Cart bubble updated as last resort: ${count} items`);
        } catch (e) {
            console.warn("Cart bubble update failed:", e);
        }
    }


    handleErrorMessage(e = !1) {
        this.hideErrors || (
            this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector(".product-form__error-message-wrapper"),
            this.errorMessageWrapper && (
                this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector(".product-form__error-message"),
                this.errorMessageWrapper.toggleAttribute("hidden", !e),
                e
            ) && (this.errorMessage.textContent = e)
        );
    }
});